// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"866":"2bd58e1c","886":"d0d5a7b8"}[chunkId] + ".chunk.js";
};